import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction, RequestQueryObject } from '@frontend/api';

export const useDeleteQuickbooksInfo: MutationFunction<
  unknown,
  void,
  [{ groupId: string }],
  RequestQueryObject
> = ({ groupId }, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: () =>
      request(`/integrations/quickbooks/groups/${groupId}`, {
        init: { method: 'DELETE' },
      }),
    ...queryOptions,
    mutationKey: ['deleteQuickbooksInfo'],
  });
};
